import reactStringReplace from 'react-string-replace';
import React from 'react';
import { HIGHLIGHT_CONTAINER_CLASS } from '../constants';

export const withHighlightAsElement = (text: string, highlightText?: string) => {
  if (!highlightText) {
    return text;
  }

  return reactStringReplace(text, highlightText, (match) => <span className={HIGHLIGHT_CONTAINER_CLASS}>{match}</span>);
};
